import { Divider, message } from "antd"
import PropTypes from "prop-types"
import React, { useEffect } from "react"
import Geocode from "react-geocode"
import styled from "styled-components"
import { uid } from "uid"

import AppButton from "../../../../../../_shared/components/AppButton"
import { MAPS_API_KEY } from "../../../../../../_shared/components/Map"
import { slotsEffect } from "../DateForm"
import Location from "./Location"

const mapsApiKey = MAPS_API_KEY

// https://www.npmjs.com/package/react-geocode
Geocode.setApiKey(mapsApiKey)
Geocode.setLanguage("it")
Geocode.setRegion("it")
Geocode.setLocationType("ROOFTOP")

// ----------------------------------------------------------------------------

function _LocationForm(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { values, onValueChange, eventTypes, initialValues } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        slotsEffect(values, eventTypes, onValueChange)
        //eslint-disable-next-line
    }, [values?.days, values?.eventType, eventTypes, values?.locations])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleLocationChange(index) {
        return (field, value) => {
            const newLocations = [...(values.locations ?? [])]
            newLocations[index][field] = value
            onValueChange("locations")(newLocations)
        }
    }

    function handleAddLocation() {
        if (!values.eventType) {
            message.error(
                "Selezionare una tipologia prima di configurare le location"
            )
        }

        const handler = onValueChange("locations")

        const newLocations = [
            ...(values.locations ?? []),
            {
                code: uid(),
                city: "",
                address: "",
                province: "",
                location: null, // lat, lng
            },
        ]
        handler(newLocations)
    }

    function handleDeleteLocation(index) {
        const handler = onValueChange("locations")
        const newLocations = [...(values.locations ?? [])]
        newLocations.splice(index, 1)
        handler(newLocations)
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={props.className}>
            {values?.locations?.map((location, index) => {
                let canDelete = true
                if (
                    initialValues?.locations?.some(
                        (l) => l.code === location.code
                    )
                ) {
                    canDelete = false
                }
                return (
                    <>
                        <Location
                            key={location.code}
                            values={location}
                            onChange={handleLocationChange(index)}
                            index={index}
                        ></Location>
                        {canDelete && (
                            <AppButton
                                className="del-btn"
                                uxType="delete"
                                onClick={() => handleDeleteLocation(index)}
                            >
                                Elimina
                            </AppButton>
                        )}
                        <Divider />
                    </>
                )
            })}
            <AppButton uxType="primary" onClick={handleAddLocation}>
                Aggiungi location
            </AppButton>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_LocationForm.propTypes = {
    className: PropTypes.string.isRequired,
    values: PropTypes.object,
    onValueChange: PropTypes.func,
    onCoordinateChange: PropTypes.func,
    city: PropTypes.object,
    province: PropTypes.object,
    address: PropTypes.object,
    eventTypes: PropTypes.array,
    initialValues: PropTypes.object,
}

_LocationForm.defaultProps = {}

// ----------------------------------------------------------------------------

const LocationForm = styled(_LocationForm)`
    & {
        .del-btn {
            margin-top: 20px;
        }
        .heading {
            margin-top: 30px;
        }
        input {
            font-size: 16px !important;
        }
        .input {
            width: 300px;
        }
        .address {
            margin: 30px 0px;
            width: 600px;
        }
        .coords {
            display: flex;
            flex-direction: row;
            padding-top: 10px;
            .input:first-child {
                margin-right: 50px;
            }
        }
        .map-picker {
            width: 500px !important;
        }
    }
`
// ----------------------------------------------------------------------------

export default LocationForm
